"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var Box_1 = __importDefault(require("@material-ui/core/Box"));
var styles_1 = require("@material-ui/core/styles");
var Button_1 = __importDefault(require("@material-ui/core/Button"));
var FormLabel_1 = __importDefault(require("@material-ui/core/FormLabel"));
var useStyles = styles_1.makeStyles(function (theme) {
    return ({
        header: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: theme.spacing(1.5, 3, 1.5, 3),
            borderBottom: "1px solid " + theme.palette.text.secondary
        },
        title: {
            color: theme.palette.text.primary,
            fontSize: '1.25rem',
            fontWeight: '500',
            lineHeight: '1.6',
            letterSpacing: '0.0075em'
        },
        body: {
            position: 'relative',
            padding: theme.spacing(3, 7, 3, 3)
        }
    });
});
var Frames = function (props) {
    var classes = useStyles();
    var children = props.children, title = props.title, onClick = props.onClick, _a = props.isHeader, isHeader = _a === void 0 ? false : _a;
    return (react_1["default"].createElement(Box_1["default"], { className: classes.container },
        isHeader && (react_1["default"].createElement("div", { className: classes.header },
            react_1["default"].createElement(FormLabel_1["default"], { className: classes.title }, title),
            react_1["default"].createElement(Button_1["default"], { variant: "contained", color: "primary", onClick: onClick }, "Add"))),
        react_1["default"].createElement("div", { className: classes.body }, children)));
};
exports["default"] = Frames;
